import { ChipWithTooltip, SecondaryButton } from "ui";
import useQueueStore from "../../../../stores/queue-store";
import { Appointment, QUEUE_TYPE } from "@elixir/types";
import useCheckInAppointment from "../../../../apis/tryst/check-in-appointment";
import { PersonWalkingDashedLineArrowRightRegularIcon } from "@elixir/icons";
import { isClinicLevelApt } from "@elixir/utils";
import { Dropdown } from "antd";
import SelectDoctorMenu from "../../../cards/queue/select-doctor-menu";
import { getQueueTypeFromStatus } from "../../../../utils/appointment-utils";

const CheckInButton = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const setSelectedDate = useQueueStore((state) => state.setSelectedDate);

  const { mutateAsync: putCheckInAppointment, isLoading } =
    useCheckInAppointment();

  const handleCheckinClick = async () => {
    const response = await putCheckInAppointment({ appointment: apt });
    if (response.success) {
      setSelectedDate(new Date());
    }
  };
  const queueType = getQueueTypeFromStatus(apt.status);
  return queueType === QUEUE_TYPE.BOOKED &&
    isClinicLevelApt({ docId: apt.doctor_oid }) ? (
    <Dropdown
      className=""
      trigger={["click"]}
      overlay={<SelectDoctorMenu aptData={apt} onSelect={handleCheckinClick} />}
    >
      <SecondaryButton
        title="Check in"
        onClick={() => {}}
        IconComponent={() => <PersonWalkingDashedLineArrowRightRegularIcon />}
        buttonIconPosition="left"
        isLoading={isLoading}
        isDisabled={isLoading}
        extraClass={className}
      />
    </Dropdown>
  ) : (
    <ChipWithTooltip
      title="Check in"
      tooltipText="Check-in"
      icon={<PersonWalkingDashedLineArrowRightRegularIcon />}
      onClick={handleCheckinClick}
      className={className}
      type={type}
    />
  );
};

export default CheckInButton;
